import React from 'react';
// import PropTypes from 'prop-types';
import {
  Label,
} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Services from './services';
import { DatetimePicker } from '../../../commons/controls';
import SelectField from '../../../components/Form/SelectField';
import moment from 'moment';

const MusorForm = (props) => {
  const {
    modositas,
    formEloadas,
    formHelyszin,
    formPublickezdete,
    formPublicvege,
    handleDateInputChange,
    handleSelectInputChange,
    eloadasOptions,
    helyszinOptions
  } = props;

  const style = {
    margin: '10px'
  };

  const handleDateInput = (e, v, field) => {
    switch (field) {
      case 'formPublicvege':
        handleDateInputChange(e, moment(v).endOf('day'), field);
        break;
      default:
        handleDateInputChange(e, v, field);
    }
  }

  const renderForm = () => {
    return (
      <React.Fragment>
        <div className="row" style={style}>
          <div className="col-md-3" style={{ paddingRight: '2px' }}>
            <SelectField
              label='Előadás:'
              name="formEloadas"
              id="formEloadas"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formEloadas')}
              options={eloadasOptions}
              // loadOptions={_.debounce(loadEloadasokOptions, 1000)}
              getOptionLabel={option => option.cim}
              getOptionValue={option => option.id}
              value={formEloadas}
              isSearchable
              isClearable
              defaultOptions
              required
            />
          </div>
          <div className="col-md-3" style={{ paddingRight: '2px' }}>
            <SelectField
              label='Helyszín:'
              name="formHelyszin"
              id="formHelyszin"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formHelyszin')}
              options={helyszinOptions}
              // loadOptions={_.debounce(loadHelyszinekOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formHelyszin}
              isSearchable
              isClearable
              defaultOptions
              required
            />
          </div>
          <div className="col-md-3">
            <DatetimePicker
              label={'Publikálás kezdete: '}
              onChange={(e, v) => handleDateInput(e, v, 'formPublickezdete')}
              value={formPublickezdete && new Date(formPublickezdete)}
              id="formPublickezdete"
              name="formPublickezdete"
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-3">
            <DatetimePicker
              label={'Publikálás vége: '}
              onChange={(e, v) => handleDateInput(e, v, 'formPublicvege')}
              value={formPublicvege && new Date(formPublicvege)}
              id="formPublicvege"
              name="formPublicvege"
              timePrecision="seconds"
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  return (
    <div className="row">
      <div className="col-md-12">
        {renderForm()}
      </div>
    </div>
  );
}

MusorForm.propTypes = {
  modositas: PropTypes.bool,
  formEloadas: PropTypes.any,
  formHelyszin: PropTypes.any,
  formPublickezdete: PropTypes.any,
  formPublicvege: PropTypes.any,
  handleDateInputChange: PropTypes.func,
  handleSelectInputChange: PropTypes.func
};

export default MusorForm;
